function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.1-Home",
  transform: "translate(-289.000000, -70.000000)",
  fill: "#45A3BB"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebar"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(15.000000, 69.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M276.746094,8.52734375 C277.402347,9.18359703 278.199214,9.51171875 279.136719,9.51171875 C280.074223,9.51171875 280.87109,9.18359703 281.527344,8.52734375 C282.183597,7.87109047 282.511719,7.07422344 282.511719,6.13671875 C282.511719,5.19921406 282.183597,4.40234703 281.527344,3.74609375 C280.87109,3.08984047 280.074223,2.76171875 279.136719,2.76171875 C278.199214,2.76171875 277.402347,3.08984047 276.746094,3.74609375 C276.08984,4.40234703 275.761719,5.19921406 275.761719,6.13671875 C275.761719,7.07422344 276.08984,7.87109047 276.746094,8.52734375 Z M283.636719,9.51171875 L287.363281,13.2382812 L286.238281,14.3632812 L282.511719,10.6367188 L282.511719,10.0390625 L282.300781,9.828125 C281.410152,10.6015664 280.355475,10.9882812 279.136719,10.9882812 C277.777337,10.9882812 276.623052,10.5195359 275.673828,9.58203125 C274.724605,8.64452656 274.25,7.49610055 274.25,6.13671875 C274.25,4.77733695 274.724605,3.62305162 275.673828,2.67382812 C276.623052,1.72460463 277.777337,1.25 279.136719,1.25 C280.496101,1.25 281.644527,1.72460463 282.582031,2.67382812 C283.519536,3.62305162 283.988281,4.77733695 283.988281,6.13671875 C283.988281,7.35547484 283.601566,8.4101518 282.828125,9.30078125 L283.039062,9.51171875 L283.636719,9.51171875 Z",
  id: "search"
})))));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.ee317398.svg";
export { ForwardRef as ReactComponent };